/* eslint-env browser, es6 */
import m from "mithril";

export class GameLoadingView implements m.Component {
  view(): m.Children {
    return m("p", "Loading...");
  }
}
